import React, { useEffect, useState } from "react";
import api from "../utils/axiosConfig";
import localforage from "localforage";
import Dashboard from "./Dashboard";

const API_URL = process.env.REACT_APP_API_URL;
const UPLOAD_ADMINS = ["pardhasaradhi@showtimeconsulting.in"];
const YNM = ["Yes", "No", "May be"];

const DROPDOWN_FIELDS = [
  ["voterListReceivedAtOffice", "Voter list received at party office?"],
  ["voterListDistributed", "Voter List Distributed?"],
  ["casteCensusStatus", "Caste Census Status?"],
  ["voterListReceived", "Voter List Received?"],
  ["boothPradhanAppointed", "Booth Pradhan Appointed?"],
  ["womenBoothPradhanAppointed", "Women Booth Pradhan Appointed?"],
  ["scBoothPradhanAppointed", "SC Booth Pradhan Appointed?"],
  ["bcBoothPradhanAppointed", "BC Booth Pradhan Appointed?"],
  ["youthBoothPradhanAppointed", "Youth Booth Pradhan Appointed?"],
  ["committee11Formed", "Total 11 member committee formed?"],
  ["circleInchargeMapped", "Circle Incharge Mapped?"],
];
const TEXT_FIELDS = [
  ["circleInchargeName", "Name of the circle incharge"],
  ["boothPocName", "Name of Booth POC mapped"],
  ["remark", "Remark"],
];

const emptyForm = () => {
  const f = {};
  DROPDOWN_FIELDS.forEach(([k]) => (f[k] = ""));
  TEXT_FIELDS.forEach(([k]) => (f[k] = ""));
  return f;
};

const BoothWiseDetails = () => {
  const [email, setEmail] = useState("");
  const [acNo, setAcNo] = useState(null);
  const [ac, setAc] = useState("");
  const [booths, setBooths] = useState([]);
  const [assigned, setAssigned] = useState(true);
  const [view, setView] = useState("list");
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  const [selectedPart, setSelectedPart] = useState("");
  const [form, setForm] = useState(emptyForm());
  const [formStatus, setFormStatus] = useState("draft");
  const [saving, setSaving] = useState(false);

  const [geo, setGeo] = useState({ districts: [], byDistrict: {} });
  const [upDistrict, setUpDistrict] = useState("");
  const [upAcNo, setUpAcNo] = useState("");
  const [upFile, setUpFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const isAdmin = UPLOAD_ADMINS.includes((email || "").toLowerCase());

  const authHeader = async () => {
    const token = await localforage.getItem("token");
    return { Authorization: `Bearer ${token}` };
  };

  useEffect(() => {
    localforage.getItem("email").then((e) => setEmail(e || ""));
  }, []);

  const loadBooths = async () => {
    setLoading(true);
    try {
      const headers = await authHeader();
      const res = await api.get(`${API_URL}/booth-wise/my-booths`, { headers });
      setAssigned(!!res.data.assigned);
      setAcNo(res.data.acNo);
      setAc(res.data.ac || "");
      setBooths(res.data.booths || []);
    } catch (e) {
      setMsg("Could not load booths.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBooths();
  }, []);

  useEffect(() => {
    (async () => {
      if (!isAdmin) return;
      try {
        const headers = await authHeader();
        const res = await api.get(`${API_URL}/booth-wise/geo`, { headers });
        setGeo(res.data || { districts: [], byDistrict: {} });
      } catch (e) {
        /* ignore */
      }
    })();
  }, [isAdmin]);

  const openForm = async (partNo) => {
    setSelectedPart(String(partNo));
    setMsg("");
    try {
      const headers = await authHeader();
      const res = await api.get(`${API_URL}/booth-wise/details`, {
        headers,
        params: { acNo, partNo },
      });
      const f = emptyForm();
      if (res.data.details) {
        const d = res.data.details;
        [...DROPDOWN_FIELDS, ...TEXT_FIELDS].forEach(([k]) => (f[k] = d[k] || ""));
        setFormStatus(d.status || "draft");
      } else {
        setFormStatus("draft");
      }
      setForm(f);
      setView("form");
    } catch (e) {
      setMsg("Could not open the form.");
    }
  };

  const onPartPick = (val) => {
    if (val) openForm(Number(val));
  };

  const saveForm = async (status) => {
    if (!selectedPart) { setMsg("Select a Part first."); return; }
    setSaving(true);
    setMsg("");
    try {
      const headers = await authHeader();
      const b = booths.find((x) => String(x.partNo) === String(selectedPart));
      await api.post(
        `${API_URL}/booth-wise/details`,
        {
          acNo,
          ac,
          partNo: Number(selectedPart),
          partRaw: b ? b.partRaw : "",
          status,
          ...form,
        },
        { headers }
      );
      setMsg(status === "submitted" ? "Submitted successfully." : "Saved as draft.");
      if (status === "submitted") setFormStatus("submitted");
    } catch (e) {
      setMsg(e.response?.data?.error || "Could not save.");
    } finally {
      setSaving(false);
    }
  };

  const doUpload = async () => {
    if (!upDistrict || !upAcNo || !upFile) { setMsg("Pick District, Assembly and a CSV file."); return; }
    setUploading(true);
    setMsg("");
    try {
      const headers = await authHeader();
      const opt = (geo.byDistrict[upDistrict] || []).find((a) => String(a.ac_no) === String(upAcNo));
      const fd = new FormData();
      fd.append("district", upDistrict);
      fd.append("ac", opt ? opt.ac_name : "");
      fd.append("acNo", upAcNo);
      fd.append("file", upFile);
      const res = await api.post(`${API_URL}/booth-wise/upload`, fd, { headers });
      setMsg(res.data.message || "Uploaded.");
      setUpFile(null);
      loadBooths();
    } catch (e) {
      setMsg(e.response?.data?.error || "Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  const locked = formStatus === "submitted" && !isAdmin;

  return (
    <div>
      <Dashboard />
      <div style={{ padding: "20px", maxWidth: "1100px", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center" }}>Booth Wise Details</h2>
        {msg && <p style={{ textAlign: "center", color: "#1f6fd0", fontWeight: 600 }}>{msg}</p>}

        {isAdmin && (
          <div style={{ border: "1px solid #e3e9f1", borderRadius: "12px", padding: "14px", background: "#fbfcfe", marginBottom: "18px" }}>
            <div style={{ fontWeight: 700, marginBottom: "10px" }}>Admin: Upload Booth List (CSV)</div>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "end" }}>
              <div>
                <label style={{ display: "block", fontSize: "13px" }}>District</label>
                <select value={upDistrict} onChange={(e) => { setUpDistrict(e.target.value); setUpAcNo(""); }}>
                  <option value="">Select District</option>
                  {geo.districts.map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: "block", fontSize: "13px" }}>Assembly</label>
                <select value={upAcNo} onChange={(e) => setUpAcNo(e.target.value)} disabled={!upDistrict}>
                  <option value="">Select Assembly</option>
                  {(geo.byDistrict[upDistrict] || []).map((a) => (
                    <option key={a.ac_no} value={a.ac_no}>{a.ac_no} - {a.ac_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: "block", fontSize: "13px" }}>CSV file</label>
                <input type="file" accept=".csv" onChange={(e) => setUpFile(e.target.files[0])} />
              </div>
              <button type="button" onClick={doUpload} disabled={uploading}
                style={{ background: "#1f6fd0", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 18px", fontWeight: 600, cursor: "pointer" }}>
                {uploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        )}

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading…</p>
        ) : !assigned ? (
          <div style={{ textAlign: "center", color: "#6a7c93", padding: "30px" }}>
            No assembly is mapped to your account. Please contact the admin.
          </div>
        ) : view === "list" ? (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
              <div style={{ fontWeight: 700, fontSize: "16px" }}>{ac} — {booths.length} booths</div>
              <button type="button" onClick={() => { setView("form"); setSelectedPart(""); setForm(emptyForm()); setFormStatus("draft"); }}
                style={{ background: "#166534", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 18px", fontWeight: 600, cursor: "pointer" }}>
                Enter Booth Details
              </button>
            </div>
            {booths.length === 0 ? (
              <p style={{ textAlign: "center", color: "#6a7c93", marginTop: "20px" }}>
                Booths for your assembly have not been uploaded yet.
              </p>
            ) : (
              <div style={{ overflowX: "auto", marginTop: "12px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#1f6fd0", color: "#fff" }}>
                      <th style={{ padding: "8px", textAlign: "left" }}>Part No</th>
                      <th style={{ padding: "8px", textAlign: "left" }}>Part Name</th>
                      <th style={{ padding: "8px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {booths.map((b) => (
                      <tr key={b._id} style={{ borderBottom: "1px solid #e3e9f1" }}>
                        <td style={{ padding: "8px" }}>{b.partNo}</td>
                        <td style={{ padding: "8px" }}>{b.partName}</td>
                        <td style={{ padding: "8px", textAlign: "center" }}>
                          <button type="button" onClick={() => openForm(b.partNo)}
                            style={{ background: "#fff", border: "1px solid #1f6fd0", color: "#1f6fd0", borderRadius: "6px", padding: "4px 12px", cursor: "pointer" }}>
                            Enter details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        ) : (
          <>
            <button type="button" onClick={() => { setView("list"); setMsg(""); }}
              style={{ background: "none", border: "none", color: "#1f6fd0", cursor: "pointer", marginBottom: "8px" }}>
              ← Back to booth list
            </button>
            <div style={{ marginBottom: "14px" }}>
              <label style={{ display: "block", fontWeight: 600, marginBottom: "4px" }}>Part</label>
              <select value={selectedPart} onChange={(e) => onPartPick(e.target.value)} style={{ minWidth: "260px" }}>
                <option value="">Select Part</option>
                {booths.map((b) => <option key={b._id} value={b.partNo}>{b.partRaw}</option>)}
              </select>
            </div>

            {selectedPart && (
              <div style={{ border: "1px solid #e3e9f1", borderRadius: "12px", padding: "16px" }}>
                {locked && <div style={{ color: "#b91c1c", fontWeight: 600, marginBottom: "10px" }}>This booth was submitted and is locked.</div>}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "12px" }}>
                  {DROPDOWN_FIELDS.map(([k, label]) => (
                    <div key={k}>
                      <label style={{ display: "block", fontSize: "13px", marginBottom: "3px" }}>{label}</label>
                      <select value={form[k]} disabled={locked} onChange={(e) => setForm({ ...form, [k]: e.target.value })} style={{ width: "100%" }}>
                        <option value="">Select</option>
                        {YNM.map((o) => <option key={o} value={o}>{o}</option>)}
                      </select>
                    </div>
                  ))}
                  {TEXT_FIELDS.map(([k, label]) => (
                    <div key={k}>
                      <label style={{ display: "block", fontSize: "13px", marginBottom: "3px" }}>{label}</label>
                      <input type="text" value={form[k]} disabled={locked} onChange={(e) => setForm({ ...form, [k]: e.target.value })} style={{ width: "100%", boxSizing: "border-box" }} />
                    </div>
                  ))}
                </div>
                {!locked && (
                  <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
                    <button type="button" onClick={() => saveForm("draft")} disabled={saving}
                      style={{ background: "#6b7280", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", fontWeight: 600, cursor: "pointer" }}>
                      Save
                    </button>
                    <button type="button" disabled={saving}
                      onClick={() => { if (window.confirm("Submit this booth? It will be locked after submission.")) saveForm("submitted"); }}
                      style={{ background: "#166534", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", fontWeight: 600, cursor: "pointer" }}>
                      Submit
                    </button>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BoothWiseDetails;
